import React from 'react';
import styled, { keyframes } from 'styled-components';
import { get } from 'lodash';

const getPrimaryColor = props =>
    (props.meta.error ? props.theme.colors.error : props.theme.colors.primary);

const getSecondaryColor = props =>
    (props.meta.error ? props.theme.colors.error : props.theme.colors.darkgray);

const LabelMovementKeyFrames = () => `
    0% {
        left: 1px;
        opacity: 1;
        top: 6px;
        font-size: 1em;
        font-weight: 300;
    }
    50% {
        font-size: 1em;
        left: 1em;
        opacity: 0;
        top: 6px;
        font-weight: 300;
    }
    50.01% {
        font-size: .90em;
        left: 1em;
        opacity: 0;
        top: -15px;

        font-weight: 400;
        padding: 0px 9px 0px 9px;
    }
    100% {
        font-size: .90em;
        opacity: 1;
        left: -8px;
        top: -15px;

        font-weight: 400;
        padding: 0px 9px 0px 9px;
    }
`;

const LabelInKeyFrames = () => keyframes`
    ${LabelMovementKeyFrames()}
`;

const LabelOutKeyFrames = () => keyframes`
    // this comment makes it different from labelIn
    ${LabelMovementKeyFrames()}
`;

const FadeInKeyFrames = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const InputWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    font-family: 'Lato', sans-serif;
    font-size: 1em;
    width: 100%;
    height: 55px;
    margin-bottom: 5px;

    & input + div {
        opacity: 0;
        background-color: transparent;
        animation: ${FadeInKeyFrames} .1s cubic-bezier(0.165, 0.840, 0.440, 1.000) .5s 1 normal forwards;
    }

    & input {
        display: inline-block;
        background-color: rgba(255,255,255,1);
        font-size: inherit;
        width: 100%;
        border: 1px solid ${props => getSecondaryColor(props)};
        padding: .80em;
        color: #000;
    }

    & input:required {
        box-shadow: none;
    }

    & input:-webkit-autofill {
        box-shadow: 0 0 0 30px rgba(255,255,255,1) inset;
    }

    & label {
        animation-name: ${LabelInKeyFrames()};
        animation-duration: .5s;
        animation-direction: reverse;
        animation-fill-mode: forwards;
        animation-timing-function: cubic-bezier(0.770, 0.000, 0.175, 1.000);
        font-size: inherit;
        display: block;
        margin: .80em;
        position: absolute;
        pointer-events: none;
        user-select: none;
        color: ${props => getSecondaryColor(props)};
        background-color: ${props => (get(props, 'children[0].props.disabled', false) ? props.theme.colors.lightgray : 'rgba(255,255,255,1)')};
        text-transform: uppercase;
    }

    & input:focus {
        border-color: ${props => getPrimaryColor(props)};
    }

    & input:focus + div label,
    & input.has-value + div label
     {
        animation-name: ${LabelOutKeyFrames()};
        animation-duration: .5s;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-timing-function: cubic-bezier(0.770, 0.000, 0.175, 1.000);
    }

    & input:focus + div label {
        color:  ${props => getPrimaryColor(props)};
    }

    ${'' /*
        TODO Update theme with ML-166
     */}
    & input:disabled {
        color: #cbcbcb;
        cursor: not-allowed;
        background-color: ${props => props.theme.colors.lightgray};
    }

    & *:focus {
        outline: 0;
    }
`;

const TextInput = ({ input = {}, name, label, type, disabled = false, meta = {}, required = true }) => {
    const hasValue = input.value && input.value.length > 0;
    return (
        <InputWrapper meta={meta}>
            <input {...input} className={hasValue ? 'has-value' : ''} name={name} type={type}
                required={required} disabled={disabled} />
            <div>
                <label htmlFor={name}>{label}</label>
            </div>
        </InputWrapper>
    );
};

export { TextInput as default };



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/TextInput.js